/**
 * Runtime platform checks used to scope workarounds to the platform that needs them.
 *
 * User-agent based on purpose: the behaviour these guard (how Android hands wallet deep-links
 * to the wallet app) has no feature test.
 */

/**
 * Whether the app is running in a browser on Android.
 * @returns true when the user agent reports Android
 */
export function isAndroid(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /android/i.test(navigator.userAgent ?? '');
}

/**
 * Whether the app is running on a phone/tablet browser (Android or iOS).
 * Used to give WalletConnect chain switches extra settle time — desktop injected
 * wallets update both connector and connection chain ids in the same tick.
 */
export function isMobile(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /android|iphone|ipad|ipod|mobile/i.test(navigator.userAgent ?? '');
}
